import { Container } from "aurelia-dependency-injection";
import { EUDocumentModel } from "./../models/eu-document";
import { GenericDocumentView } from "./generic-document";
import { MobileHelper} from "../../shared/helpers/mobile-helper";
import {DesktopModel} from "../../desktop/models/desktop";

const warningIcon = `<i class="icon fa fa-exclamation-circle" aria-hidden="true" title="Judgment subsequently delivered"></i>`;
const dom = {
        DOCUMENT_NAVIGATION: ".document-navigator",
        STAGE_ALERT: ".stage-alert",
        DOCUMENT_ALERT: ".document-alert",
        MOBILE_REQUEST_ALL_RELATIONS: ".mobile-request-all-relations",
        MOBILE_HIDDEN_NEUTRAL_TREATMENTS_ALERT: ".mobile-hidden-neutral-treatments-alert",
        PANEL_SWITCHER: ".switch-button",
};

export class EUDocumentView extends GenericDocumentView {

        public model: EUDocumentModel;
        private mobileHelper: MobileHelper = Container.instance.get(MobileHelper);
        private desktopModel: DesktopModel = Container.instance.get(DesktopModel);

        public onShow() {
                super.onShow();
                this.setupModelEvents();
                this.setupDocumentAlert();
        }

        public setupModelEvents() {
                this.listenTo(this.desktopModel, "change:MultipleMode", this.setupDocumentAlert);
        }

        public events(): Backbone.EventsHash {
                const events: Backbone.EventsHash = super.events();
                events["click " + dom.DOCUMENT_ALERT] = (e) => this.stageAlertClicked(e);
                const mh: MobileHelper = Container.instance.get(MobileHelper); // Can't use the class reference to this, guess that code hasn't run to initialise it at this point
                return events;
        }

        private setupDocumentAlert() {
                let message = "";
                if (!this.model.IsLatestJudgment) {
                        message += warningIcon;
                        message += `<span class="stage-alert"><span class="stage-alert-message-${this.desktopModel.MultipleMode ? "multimode" : "singlemode"}"> Judgment subsequently delivered.  </span></span>`;
                }
                if (message) {
                        this.$(dom.DOCUMENT_ALERT).show();
                        this.$(dom.DOCUMENT_ALERT).html(message);
                } else {
                        this.$(dom.DOCUMENT_ALERT).hide();
                }
        }
        private stageAlertClicked(e: JQueryEventObject): void {
                e.stopPropagation();
                this.$(dom.DOCUMENT_NAVIGATION).find(".dropdown-toggle").dropdown("toggle");
        }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/eu-document.ts